import React from 'react';
import './StatsCard.css';

const StatsCard = ({ title, value, icon, color, percentage, trend }) => {
  return (
    <div className={`stats-card ${color}`}>
      <div className="stats-card-body">
        <div className="stats-info">
          <p className="stats-title">{title}</p>
          <h3 className="stats-value">{value}</h3>
          {percentage && (
            <div className={`stats-trend ${trend}`}>
              <span className="trend-icon">
                {trend === 'up' ? '↑' : '↓'}
              </span>
              <span className="trend-value">{percentage}%</span>
              <span className="trend-text">vs last month</span>
            </div>
          )}
        </div>
        <div className="stats-icon">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;